<template>
	<button
		class="text-gray-400 hover:text-gray-300 focus:text-gray-300 w-16 h-16 inline-flex items-center justify-center relative"
		@click="$emit('click')"
	>
		<BaseIcon name="mono/help-circle" />
		<div v-if="showRedDot" class="absolute top-0 right-0 h-6 w-6 bg-red-500 rounded-full" />
	</button>
</template>

<script>
export default {
	name: 'ButtonQuestionMark',
	props: {
		showRedDot: Boolean,
	},
	emits: ['click'],
}
</script>
